module.exports = __webpack_public_path__ + "static/media/consulta_doc.1fe7bbff.svg";